/* Proprietary - see LICENSE */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Login.css';
import apiClient from '../config/apiClient';

const MfaVerify = ({ mfaToken, onComplete }) => {
  const { t } = useTranslation();
  const [code, setCode] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleVerify = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await apiClient.post('/auth/mfa/verify', { code, rememberMe }, {
        headers: { 'x-mfa-token': mfaToken },
      });

      // Store auth tokens
      sessionStorage.setItem('token', response.data.access_token);
      if (response.data.refresh_token) {
        sessionStorage.setItem('refreshToken', response.data.refresh_token);
      }
      sessionStorage.setItem('user', JSON.stringify(response.data.user));

      // Store remember-me token in localStorage (persists across sessions)
      if (response.data.mfaRememberToken) {
        localStorage.setItem('mfaRememberToken', response.data.mfaRememberToken);
      }

      const role = response.data?.user?.role;
      const isMultiTenant = response.data?.user?.multiTenant === true;
      const shouldSelectTenant = ['super_admin', 'owner', 'provider_admin'].includes(role) || isMultiTenant;
      if (shouldSelectTenant) {
        sessionStorage.removeItem('selectedTenantId');
      } else if (response.data?.user?.tenantId) {
        sessionStorage.setItem('selectedTenantId', response.data.user.tenantId);
      }

      onComplete();
    } catch (err) {
      setError(err.response?.data?.message || t('mfa.invalidCode'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img className="login-logo" src="/images/inco-logo4.png" alt="INCO" />
          <h2 style={{ margin: '0 0 0.5rem', color: '#0f172a', fontSize: '1.25rem' }}>{t('mfa.verifyTitle')}</h2>
          <p style={{ fontSize: '0.9rem', color: '#64748b' }}>{t('mfa.verifySubtitle')}</p>
        </div>

        <form onSubmit={handleVerify} className="login-form">
          {error && <div className="error-message">{error}</div>}

          <div className="form-group">
            <label htmlFor="mfa-code">{t('mfa.enterCode')}</label>
            <input
              type="text"
              id="mfa-code"
              value={code}
              onChange={(e) => {
                const val = e.target.value.replace(/\D/g, '').slice(0, 6);
                setCode(val);
              }}
              required
              placeholder="000000"
              autoComplete="one-time-code"
              inputMode="numeric"
              maxLength={6}
              autoFocus
              style={{ textAlign: 'center', letterSpacing: '0.5em', fontSize: '1.5rem' }}
            />
            <p style={{ fontSize: '0.8rem', color: '#64748b', marginTop: '0.25rem' }}>
              {t('mfa.codeHint')}
            </p>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <input
              type="checkbox"
              id="remember-me"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
              style={{ width: 16, height: 16, cursor: 'pointer' }}
            />
            <label htmlFor="remember-me" style={{ fontSize: '0.9rem', color: '#475569', cursor: 'pointer', fontWeight: 400 }}>
              {t('mfa.rememberDevice')}
            </label>
          </div>

          <button type="submit" className="btn btn-primary btn-block" disabled={loading || code.length !== 6}>
            {loading ? t('mfa.verifying') : t('mfa.verify')}
          </button>
        </form>
      </div>
    </div>
  );
};

export default MfaVerify;
